import React from 'react';
import { C, Sum } from 'shared/helpers';
import PropTypes from 'prop-types';

import Styles from './Table.module.scss';

export default function Table({ etapas, tableKey, id }) {
  const { Table, Rowee, Block, Double, Lighter, Total, Diferenca } = Styles;

  let divCount = 0;

  const width = (width) => ({
    minWidth: `${width}%`,
    maxWidth: `${width}%`,
  });

  const fixe = (res, fix) => (fix ? res.toFixed(fix).replace('.', ',') : res);

  const PercentSum = (etapa, el, fase, mod = 1, fix = 2) => {
    const res =
      Sum(
        etapa.produtos
          .filter((x) => x.fase_id === fase)
          .map(
            (produto) =>
              Number(produto[el]) * (Number(produto.quantidade) / mod),
          ),
      ) || 0;
    return fixe(res, fix);
  };

  const NR = (etapa, el, fase) => {
    const res =
      (PercentSum(etapa, el, fase, 1, 0) / PercentSum(etapa, 'N', fase, 1, 0)) *
        100 || 0;
    return Intl.NumberFormat('pt-br', { maximumFractionDigits: 0 }).format(res);
  };

  const TNR = (etapas, el, fase) => {
    const N = Sum(etapas.map((etapa) => PercentSum(etapa, 'N', fase, 1, 0)));
    const E = Sum(etapas.map((etapa) => PercentSum(etapa, el, fase, 1, 0)));
    const res = (E / N) * 100;
    return Intl.NumberFormat('pt-br', { maximumFractionDigits: 0 }).format(
      res || 0,
    );
  };

  const TotalPercentSum = (etapas, el, fase, mod = 1, fix = 2) => {
    const res = Sum(etapas.map((etapa) => PercentSum(etapa, el, fase, mod, 0)));
    return fix ? res.toFixed(fix) : res;
  };

  const Diff = (etapas, el, fix = 2) => {
    const [el1, el2] = [
      TotalPercentSum(etapas, el, 2, 100),
      TotalPercentSum(etapas, el, 3, 100),
    ];
    const res = el1 - el2;
    let resPerc = (el1 / el2) * 100 - 100;
    if (resPerc === Infinity) {
      resPerc = 0;
    }
    return [fixe(res, fix), fixe(resPerc ? resPerc.toFixed(0) : 0, 0)];
  };

  const TotalNDiff = (etapas, el, fix = 2) => {
    const res =
      TotalPercentSum(etapas, el, 2, 100) - TotalPercentSum(etapas, el, 3, 100);
    return fixe(res, fix);
  };

  return (
    <div className={Table}>
      <header>
        <div style={width(14)}>Etapa Fenológica</div>
        <div style={width(14)}> Época de aplicação</div>
        <div style={width(12)}>Nutrição</div>
        <div style={width(15)}>NO3 - Nítrico (kg/ha) - (%)</div>
        <div style={width(15)}>NH4 - Amoniacal (kg/ha) - (%)</div>
        <div style={width(15)}>NH2 - Amídico (kg/ha) - (%)</div>
        <div style={width(15)}>N - Total</div>
      </header>
      <div>
        {etapas.map((e, index) => (
          <div
            key={`${tableKey}${++divCount}`}
            className={index % 2 === 0 ? Rowee : C(Rowee, Lighter)}
          >
            <div style={width(14)} className={C(Block, Double)}>
              {e.fenologica}
            </div>
            <div style={width(14)} className={C(Block, Double)}>
              {e.aplicacao}
            </div>
            <div style={width(12)}>
              <div className={Block}>SQM VITAS</div>
              <div className={Block}>Convencional</div>
            </div>
            {['NO3', 'NH4', 'NH2'].map((el) => (
              <div key={`${tableKey}${++divCount}`} style={width(15)}>
                <div className={Block} id={`${id}_sqm_${el}_${index}`}>
                  {`${PercentSum(e, el, 2, 100)} Kg/ha - ${NR(e, el, 2)}%`}
                </div>
                <div className={Block} id={`${id}_conv_${el}_${index}`}>
                  {`${PercentSum(e, el, 3, 100)} Kg/ha - ${NR(e, el, 3)}%`}
                </div>
              </div>
            ))}
            <div style={width(15)}>
              <div className={Block} id={`${id}_sqm_total_${index}`}>
                {`${PercentSum(e, 'N', 2, 100)} Kg/ha`}
              </div>
              <div className={Block} id={`${id}_conv_total_${index}`}>
                {`${PercentSum(e, 'N', 3, 100)} Kg/ha`}
              </div>
            </div>
          </div>
        ))}
        <div className={C(Rowee, Total)}>
          <div style={width(28)} className={C(Block, Double)}>
            TOTAL
          </div>
          <div style={width(12)}>
            <div className={C(Block, Total)}>SQM VITAS</div>
            <div className={Block}>Convencional</div>
          </div>
          {['NO3', 'NH4', 'NH2'].map((el) => (
            <div key={`${tableKey}${++divCount}`} style={width(15)}>
              <div className={C(Block, Total)} id={`${id}_sqm_total_${el}`}>
                {`${TotalPercentSum(etapas, el, 2, 100).replace(
                  '.',
                  ',',
                )} Kg/ha - 
                ${TNR(etapas, el, 2)}%`}
              </div>
              <div className={Block} id={`${id}_conv_total_${el}`}>
                {`${TotalPercentSum(etapas, el, 3, 100).replace(
                  '.',
                  ',',
                )} Kg/ha - 
                ${TNR(etapas, el, 3)}%`}
              </div>
            </div>
          ))}
          <div style={width(15)}>
            <div className={C(Block, Total)} id={`${id}_sqm_total`}>
              {`${TotalPercentSum(etapas, 'N', 2, 100).replace(
                '.',
                ',',
              )} Kg/ha`}
            </div>
            <div className={Block} id={`${id}_conv_total`}>
              {`${TotalPercentSum(etapas, 'N', 3, 100).replace(
                '.',
                ',',
              )} Kg/ha`}
            </div>
          </div>
        </div>
        <div className={Rowee}>
          <div className={C(Block, Diferenca)} style={width(40)}>
            Diferença
          </div>
          {['NO3', 'NH4', 'NH2'].map((el) => (
            <div
              key={`${tableKey}${++divCount}`}
              style={width(15)}
              id={`${id}_diff_${el}`}
            >
              <div className={C(Block, Diferenca)}>
                {`${Diff(etapas, el).join(' Kg/ha (').concat('%)')}`}
              </div>
            </div>
          ))}
          <div style={width(15)}>
            <div className={C(Block, Diferenca)} id={`${id}_total_diff`}>
              {`${TotalNDiff(etapas, 'N')} Kg/ha`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Table.propTypes = {
  tableKey: PropTypes.string.isRequired,
  etapas: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
};
